// import partials
import appRecommendation from './appRecommendation';
import collaborationMap from './collaborationMap';
import cropStageProgram from './cropStageProgram';
import cropsFinder from './cropsFinder';
import downloads from './downloads';
import heroSlider from './heroSlider';
import organicFarming from './organicFarming';
import { productFinder, productFinderFilters } from './productFinder';
import salesContact from './salesContact';
import search from './search';
import socialMedia from './socialMedia';

const translationStrings = {
  ...appRecommendation,
  ...collaborationMap,
  ...cropStageProgram,
  ...cropsFinder,
  ...downloads,
  ...heroSlider,
  ...organicFarming,
  ...productFinder,
  ...productFinderFilters,
  ...salesContact,
  ...search,
  ...socialMedia,

  // common/shared strings
  all: Drupal.t('All'),
  crop: Drupal.t('Crop'),
  crops: Drupal.t('Crops'),
  filterLabel: Drupal.t('Filter'),
  general: Drupal.t('General'),
  in: Drupal.t('in'),
  learnMore: Drupal.t('Learn more'),
  loading: Drupal.t('Loading'),
  new: Drupal.t('New'),
  next: Drupal.t('Next'),
  noResults: Drupal.t('No results found.'),
  previous: Drupal.t('Previous'),
  relatedProductsTitle: Drupal.t('Related Products'),
  visit: Drupal.t('Visit'),
};

export default translationStrings;
